"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndOperation = exports.DEFAULT_CONFIG = exports.AmqplibInstrumentation = void 0;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var amqplib_1 = require("./amqplib");
Object.defineProperty(exports, "AmqplibInstrumentation", { enumerable: true, get: function () { return amqplib_1.AmqplibInstrumentation; } });
var types_1 = require("./types");
Object.defineProperty(exports, "DEFAULT_CONFIG", { enumerable: true, get: function () { return types_1.DEFAULT_CONFIG; } });
Object.defineProperty(exports, "EndOperation", { enumerable: true, get: function () { return types_1.EndOperation; } });
//# sourceMappingURL=index.js.map